import axios from 'axios';
import { AppConfig } from 'AppConfig';

export default function getUrlTicket(aUrl, tenantCd) {
  return new Promise(function (resolve, reject) {
    if (aUrl == null || aUrl.indexOf('localhost') > 0) {
      return resolve(aUrl);
    }
    if (aUrl.indexOf('dummyip') > 0) {
      aUrl = aUrl.replace('dummyip', AppConfig.TB_DEV_URL);
    }

    const trimmedTenantCd = typeof tenantCd === 'string' ? tenantCd.trim() : '';
    const ticketEndpoint = AppConfig.FO_INITIAL_URL + '/tbl/ticket';
    const ticketRequest = trimmedTenantCd
      ? axios.post(ticketEndpoint, null, { params: { tenantCd: trimmedTenantCd } })
      : axios.post(ticketEndpoint);

    ticketRequest
      .then((r) => {
        if (r == null || r.data == null || r.data === '' || String(r.data) === '-1') {
          return reject(`Tableau trusted ticket unavailable for: ${aUrl} (response data: ${String(r?.data).substring(0, 50)})`);
        } else if (aUrl.indexOf('tableauToken') > 0) {
          aUrl = aUrl.replace(/tableauToken/, r.data);
        } else {
          const parts = aUrl.split('/');
          parts[4] = r.data;
          aUrl = parts.join('/');
        }
        resolve(aUrl);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
